import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const ExclamationBoardIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M3.2 20C2.595 20 2.07708 19.7919 1.64625 19.3758C1.21542 18.9596 1 18.4594 1 17.875V5.125C1 4.54062 1.21542 4.04036 1.64625 3.62422C2.07708 3.20807 2.595 3 3.2 3H20.8C21.405 3 21.9229 3.20807 22.3538 3.62422C22.7846 4.04036 23 4.54062 23 5.125V17.875C23 18.4594 22.7846 18.9596 22.3538 19.3758C21.9229 19.7919 21.405 20 20.8 20H3.2ZM3.2 17.875H20.8V5.125H3.2V17.875Z" />
      <path d="M12 16C11.725 16 11.4896 15.9021 11.2938 15.7063C11.0979 15.5104 11 15.275 11 15C11 14.725 11.0979 14.4896 11.2938 14.2938C11.4896 14.0979 11.725 14 12 14C12.275 14 12.5104 14.0979 12.7063 14.2938C12.9021 14.4896 13 14.725 13 15C13 15.275 12.9021 15.5104 12.7063 15.7063C12.5104 15.9021 12.275 16 12 16ZM11 13V7H13V13H11Z" />
    </SvgIcon>
  )
}
export default ExclamationBoardIcon
